import AdvertHero from "../components/AdvertContainer/AdvertHero";



export default function Homepage () {

  return (
    <>
      <AdvertHero />
    </>
  )
}

